import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
	TeacherDashboardData,
	TeacherDashboardState,
} from "../types/teacherDashboard";

const initialState: TeacherDashboardState = {
	data: {
		cumulative: {
			female: 0,
			male: 0,
			total: 0,
			studentsPresent: 0,
			studentsAbsent: 0,
			mealsServedCount: 0,
			melasNotServedCount: 0,
			studentOdCount: 0,
		},
		studentscount: [],
	},
	loading: false,
	error: null,
};

const teacherDashboardSlice = createSlice({
	name: "teacherDashboard",
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
		},
		setTeacherDashboardData: (
			state,
			action: PayloadAction<TeacherDashboardData>
		) => {
			state.data.cumulative = action.payload.cumulative;
			state.data.studentscount = action.payload.studentscount;
		},
	},
});

export const { setLoading, setError, setTeacherDashboardData } =
	teacherDashboardSlice.actions;
export default teacherDashboardSlice.reducer;
